(ns practitest.frontend.forms3.instance.step-parameters
  (:require [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.re-frame :refer [partial-dispatch
                                                         partial-dispatch-sync
                                                         partial-subscribe]]
            [practitest.frontend.components.grid.localstorage :as grid-storage]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.buttons :as buttons]
            [practitest.frontend.components2.entity-form.forms :as forms]
            [practitest.frontend.forms3.entity-form.fields :as fields3]
            [practitest.frontend.forms3.entity-form.footer :as footer]
            [practitest.frontend.routing.backend-routes :as broutes]
            [re-frame.core :as re-frame]
            [reagent.core :as reagent]))

(def form-id :step-params-instance)

(defn get-field-config
  [base-entity param-key]
  (let [project-params (:project_parameters base-entity)
        param-config (first (filter #(or (= (:key_name %) param-key)
                                         (= (:name %) param-key))
                                    (vals project-params)))
        default-value (:val param-config)
        possible-values (:step_field_list_values param-config)
        type (:type param-config)]
    (case type
      ("list" "url_list")
      {:label param-key
       :field param-key
       :field-id param-key
       :field-name param-key
       :name param-key
       :mandatory? true
       :default default-value
       :type :list
       :possible-values possible-values
       :label-fn :label
       :key-fn :key
       :edit-permissions? true}
      ;; "text" would be default type
      ;; Happens when there are parameters defined in steps but nothing in project parameters
      {:label param-key
       :field param-key
       :field-id param-key
       :field-name param-key
       :name param-key
       :type :text
       :default default-value
       :mandatory? true
       :validators (forms/get-mandatory-validator :text)
       :edit-permissions? true})))

(re-frame/reg-sub
  ::step-params-field-props
  :<- [::forms/base-entity :instance]
  (fn [base-entity [_ field-id]]
    (get-field-config base-entity field-id)))

(defn reset-form-state
  [db instance]
  (let [test-params (get-in instance [:qtest_design :referenced_parameters])]
    (reduce
      (fn [db param-key]
        (let [field-info (get-field-config instance param-key)
              field-value (get-in instance [:parameters (keyword param-key)])
              default-value (:default field-info)]
          (if-let [value (or field-value default-value)]
            (-> db (assoc-in [:form-states2 form-id :fields param-key]
                             {:value value
                              :default? (and (some? default-value)
                                             (nil? value))}))
            db)))
      (assoc-in db [:form-states2 form-id] {})
      test-params)))

(def step-params-form-props
  {:get-field-props (partial-subscribe [::step-params-field-props])
   :get-form-state (partial-subscribe [::forms/form-state form-id])
   :set-form-state (partial-dispatch [::forms/set-form-state form-id])

   :get-field-state (partial-subscribe [::forms/field-state form-id])
   :set-field-state (partial-dispatch-sync [::forms/set-field-state form-id])

   :form-ref (atom nil)})

(defn steps-pre-validation!
  [form-props]
  (footer/validate-fields! (assoc step-params-form-props
                             ;; Links for mandatory fields
                             :form-ref (:form-ref form-props))))

(defn step-parameters-section [form-props]
  (reagent/with-let [collapsed? (reagent/atom
                                  (grid-storage/get-section-collapsed :instance "step-parameters" true))]
    (let [{:keys [base-entity new? edit-permissions?]} form-props
          project-params (:project_parameters base-entity)
          test-params (get-in base-entity [:qtest_design :referenced_parameters])]
      [:<>
       (when (seq test-params)
         [:div.side-panel-section
          [:div.fields-panel
           {:class (dom/classes-pairs-v :section-collapsed @collapsed?)}
           [:div.header
            {:class (dom/classes-pairs-v :collapsed @collapsed?)}
            [buttons/icon-button
             {:icon (if @collapsed?
                      [icons/mux-chevron-right]
                      [icons/mux-chevron-down2])
              :on-click #(let [new-state (not @collapsed?)]
                           (reset! collapsed? new-state)
                           (grid-storage/set-section-collapsed :instance "step-parameters" new-state))}]
            [:div.title (get-translation "instance.step-parameters"
                                         "Step Parameters")]
            [:div.add-fields-container
             [buttons/button
              {:tertiary? true
               :text (get-translation "generic.button.configure"
                                      "Configure")
               :href (broutes/get-url-view "projects#step_params")
               :icon [icons/mux-configure-settings]}]]]
           (when-not @collapsed?
             [:div
              (into
                [:<>]
                (map
                  (fn [param-key]
                    [fields3/build-field
                     {:field-name param-key
                      :edit-permissions? edit-permissions?}
                     step-params-form-props]))
                (sort-by str/lower-case test-params))])]])])))
